import React, { useState } from 'react';

const FilterGroup = ({ title, children }) => (
  <div className="space-y-3">
    <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide border-b border-gray-200 pb-1">
      {title}
    </h3>
    {children}
  </div>
);

const FilterInput = ({ label, name, type = "text", placeholder, value, onChange, min, max }) => (
  <div className="space-y-1">
    <label className="block text-sm font-medium text-gray-900" htmlFor={name}>
      {label}
    </label>
    <input
      id={name}
      type={type}
      name={name}
      placeholder={placeholder}
      value={value || ''}
      onChange={onChange}
      min={min}
      max={max}
      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-gray-900"
      autoComplete="off"
    />
  </div>
);

const RangeFilter = ({ label, minName, maxName, minValue, maxValue, type = "number", minPlaceholder, maxPlaceholder, onChange }) => (
  <div className="space-y-1">
    <label className="block text-sm font-medium text-gray-900">
      {label}
    </label>
    <div className="grid grid-cols-2 gap-2">
      <input
        type={type}
        name={minName}
        placeholder={minPlaceholder}
        value={minValue || ''}
        onChange={onChange}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-gray-900"
      />
      <input
        type={type}
        name={maxName}
        placeholder={maxPlaceholder}
        value={maxValue || ''}
        onChange={onChange}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-gray-900"
      />
    </div>
  </div>
);

const JobFilter = ({ onApplyFilters = () => {} }) => {
  const [filters, setFilters] = useState({
    title: '',
    company: '',
    department: '',
    location: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };

  const handleApply = () => {
    onApplyFilters(filters);
  };

  const handleClear = () => {
    const clearedFilters = {
      title: '',
      company: '',
      department: '',
      location: '',
    };
    setFilters(clearedFilters);
    onApplyFilters(clearedFilters);
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg mb-6 border border-gray-100">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Filter Jobs</h2>
        <p className="text-sm text-gray-700">Narrow down your search with the filters below</p>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Basic Info */}
        <FilterGroup title="Basic Information">
          <FilterInput
            label="Job Title"
            name="title"
            placeholder="e.g. Software Engineer"
            value={filters.title}
            onChange={handleChange}
          />
          <FilterInput
            label="Company"
            name="company"
            placeholder="e.g. Google"
            value={filters.company}
            onChange={handleChange}
          />
          <FilterInput
            label="Department"
            name="department"
            placeholder="e.g. Engineering"
            value={filters.department}
            onChange={handleChange}
          />
          <FilterInput
            label="Location"
            name="location"
            placeholder="e.g. San Francisco, CA"
            value={filters.location}
            onChange={handleChange}
          />
        </FilterGroup>

        {/* Salary & Applicants */}
 
         

        {/* AI Score */}
    
      </div>

      <div className="flex justify-end items-center mt-8 pt-4 border-t border-gray-200">
        <div className="flex space-x-3">
          <button 
            onClick={handleClear} 
            className="px-6 py-2 text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors font-medium"
          >
            Clear All
          </button>
          <button 
            onClick={handleApply} 
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobFilter;